// AI-ASSISTED: generated with claude-code on 2026-06-10, reviewed by Yoann Hertienne
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export { RovoCard } from './RovoCard';

const rovoCard = EntityCardBlueprint.make({
  name: 'rovo',
  params: {
    filter: 'kind:component',
    loader: async () => {
      const { RovoCard } = await import('./RovoCard');
      return <RovoCard />;
    },
  },
});

export const rovoCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [rovoCard],
});
